export default __webpack_public_path__ + "static/media/video.5682fe6b.mp4";